import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import OlhmsRequest from './olhms_delete_account_request/RequestPage';
import TelcoMasterRequest from './telcomaster_delete_acount_request/DeletePage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <TelcoMasterRequest /> */}
    {/* <OlhmsRequest /> */}
    <App />
  </React.StrictMode>
);


// if (module.hot) {
//   module.hot.accept()
// }

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();